import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import useHover from "../hooks/useHover";

export default function NavigationItem({ to, label, Icon }) {
  const [hoverRef, isHovered] = useHover();
  return (
    <Container ref={hoverRef} to={to} isHovered={isHovered}>
      {isHovered ? label : <Icon size={24} color="inherit" />}
    </Container>
  );
}

const Container = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  text-decoration: none;
  color: ${({ theme, isHovered }) =>
    isHovered ? theme.navigationTextHover : theme.text};
  text-transform: uppercase;
  font-size: 12px;
`;
